export default {
  // 时间戳转为时间
  retun_formatDate11(time) {
    time *= 1000;
    const date = new Date(time);
    return this.formatDate(date, 'yyyy-MM-dd hh:mm');
  },
  // 秒转为时间格式
  formatSeconds(value) {
    const result = parseInt(value);
    const h = Math.floor(result / 3600) < 10 ? Math.floor(result / 3600) : Math.floor(result / 3600);
    const m = Math.floor((result / 60 % 60)) < 10 ? Math.floor((result / 60 % 60)) : Math.floor((result / 60 % 60));
    const s = Math.floor((result % 60)) < 10 ? Math.floor((result % 60)) : Math.floor((result % 60));
    let res = '';
    if (h != '0') res += `${h}h`;
    if (m != '0') res += `${m}m`;
    res += `${s}s`;
    return res;
  },
  // 13位时间戳转换时间
  retun_formatDate13(time) {
    const date = new Date(time);
    return this.formatDate(date, 'yyyy-MM-dd');
  },
  formatDate(date, fmt) {
    if (/(y+)/.test(fmt)) {
      fmt = fmt.replace(RegExp.$1, (`${date.getFullYear()}`).substr(4 - RegExp.$1.length));
    }
    const o = {
      'M+': date.getMonth() + 1,
      'd+': date.getDate(),
      'h+': date.getHours(),
      'm+': date.getMinutes(),
      's+': date.getSeconds(),
    };
    for (const k in o) {
      if (new RegExp(`(${k})`).test(fmt)) {
        const str = `${o[k]}`;
        fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? str : this.padLeftZero(str));
      }
    }
    return fmt;
  },
  padLeftZero(str) {
    return (`00${str}`).substr(str.length);
  },

};
